

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const CREATEDESIGNATION= createAsyncThunk(
  "createDesignation/createDesignation",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createDesignationSlice = createSlice({
  name: "createDesignationSlice",
  initialState: {
    createDesignation: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateDesignation: (state) => {
        state.createDesignation.loading = false
        state.createDesignation.error = false
        state.createDesignation.data = []
        state.createDesignation.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CREATEDESIGNATION.fulfilled, (state, action) => {
      state.createDesignation = {
        ...state.createDesignation,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEDESIGNATION.pending, (state, action) => {
      state.createDesignation = {
        ...state.createDesignation,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEDESIGNATION.rejected, (state, action) => {
      state.createDesignation = {
        ...state.createDesignation,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createDesignationAction = {
    CREATEDESIGNATION,
};

export { createDesignationAction };
export default createDesignationSlice.reducer;
export const {setInitialStateOfcreateDesignation} = createDesignationSlice.actions
